// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"66d10453","70":"af1a2d1d","171":"053c78fa","255":"d3f83104","466":"68dcbea0","507":"3e8ebc79","528":"8f3d927e","574":"544d4133","576":"0c372e8e","744":"4f5fe279","780":"07abda4a","923":"8f23005c","968":"132fdbe1","970":"7f189d5d"}[chunkId] + ".chunk.js";
};